<template>
    
        <v-card  class="" elevation=0 >
            <v-card-title class="pa-0">
                 
                <v-img  :src="(business.loveimage=='null' || business.loveimage==null )?bannerImg:business.loveimage" aspect-ratio="1" class="lighten-2 " max-height="287">
                    <v-row class="fill-height align-center" style="background:rgba(0,0,0, 0.4);">
                        <v-col cols="12" md="12" sm="12" class=" white--text pl-30">
                            <!-- <h2 class="heading" v-if="business.loveimagetitle==''">Love</h2> -->
                            <h2 class="heading" >{{business.loveimagetitle}}</h2>
                            <!-- <span class="body-1" v-if="business.loveimagedescription==''">Feel free to show your love for everyone to see</span> -->
                            <span class="body-1" >{{business.loveimagedescription}}</span>

                                    
                        </v-col>
                                
                    </v-row>
                            
                </v-img>
                        
                   
            </v-card-title>

            <v-card-text class="mb-auto pwa-content  pb-90">
                <v-row v-for="(item, index) in business.socialmedia" :key="index">
                    <a :href="item.value" target="_blank" class="w-100">
                    <v-col cols="12" md="12" sm="12">
                        <v-card>
                            
                            <v-row>
                                <v-col cols="4" md="4" sm="4" class="pl-20">
                                    <v-avatar style="background:#fe5800;" >
                                        <v-icon class="white--text">{{item.social_media.icon}}</v-icon>
                                    </v-avatar>    
                                </v-col>

                                <v-col cols="8" md="8" sm="8">
                                    
                                        <div class="title pt-15">
                                            {{item.social_media.name}}
                                        </div>
                                    
                                </v-col>

                            </v-row>
                        </v-card>            
                    </v-col>
                    </a>
                </v-row>
            </v-card-text>

            

        </v-card>
       
</template>
<script>
import Vue from 'vue'
export default {
    props: ['business']
    ,
  data: () => ({
    bannerImg:require('@/assets/overview-banner.jpg'),
    //bannerImg:'',
    
  }),
  
  
}
</script>
<style >
    .pl-30{
        padding-left: 30px;
    }
    .pb-90
    {
        padding-bottom: 90px;
    }
    .pl-20{
        padding-left: 20px;
    }
    .pt-15{
        padding-top: 5px;
    }
</style>